<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="part">Part 1</p>
<p class="part">P<span class="small">OPULAR</span> C<span class="small">ULTURE AS</span> P<span class="small">UBLIC</span> S<span class="small">PACE</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?ebcc6d44